import { Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useEffect, useRef, useState } from "react";
import OrganizationRequest from "../../actions/organization";
import { Autocomplete, CircularProgress, MenuItem } from "@mui/material";
import Controls from "../controls/Controls";
import { Form, useForm } from "../customHelpers/useForm";
import { Image_API } from "../../config";
import UploadImage from "../../actions/uploadImage";

const initialFValues = {
  phoneNo: "",
  address: "",
  email: "",
  profilePicture: null,
  organization_name: "",
  editing: false,
};
const useStyles = makeStyles((theme) => ({
  icon: {
    borderRadius: "50%",
    height: "40px",
    width: "40px",
  },
}));
const UpdateCompany = ({
  NotifyMessage,
  setOpenPopup,
  recordForEdit,
  getAdminData,
}) => {
  useEffect(() => {
    if (recordForEdit !== null) {
      setValues({
        ...recordForEdit,
      });
    }
  }, []);
  const [file, setfile] = useState(null);
  const { uploadImage } = UploadImage();
  const classes = useStyles();
  const { updateOrganization } = OrganizationRequest();

  const validate = (fieldValues = values) => {
    const temp = { ...errors };

    const regexEmail =
      /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if ("phoneNo" in fieldValues)
      temp.phoneNo =
        fieldValues.phoneNo?.length !== 0 ? "" : "This field is required.";
    if ("email" in fieldValues) {
      if (fieldValues?.email?.length !== 0) {
        temp.email = regexEmail.test(
          fieldValues.email?.toString().toLowerCase()
        )
          ? ""
          : "Email is not valid.";
      }
    }
    if ("address" in fieldValues)
      temp.address =
        fieldValues.address?.length !== 0 ? "" : "This field is required.";
    if ("organization_name" in fieldValues)
      temp.organization_name =
        fieldValues.organization_name?.length !== 0
          ? ""
          : "This field is required.";

    setErrors({
      ...temp,
    });
    if (fieldValues == values) return Object.values(temp).every((x) => x == "");
  };

  const { values, errors, setValues, handleInputChange, setErrors, resetForm } =
    useForm(initialFValues, true, validate);
  const handleImageChange = (e) => {
    const { files } = e.target;
    if (files.length > 0) {
      const selectedFile = files[0];
      setfile(URL.createObjectURL(selectedFile));
      setValues({ ...values, profilePicture: selectedFile });
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();

    // Append a new image file if selected
    if (values.profilePicture instanceof File) {
      formData.append("image", values.profilePicture);
    }

    if (validate()) {
      try {
        // Only upload a new image if one is selected
        if (values.profilePicture instanceof File) {
          const uploadResponse = await uploadImage(formData, "organization");
          if (uploadResponse.err) {
            NotifyMessage({ message: uploadResponse.err, type: "error" });
            setValues({ ...values, submitting: false });
            return;
          }
          values.profilePicture = uploadResponse.data.data; // Update with new image URL
        } else {
          // If no new image is selected, keep the existing one
          values.profilePicture = recordForEdit.profilePicture;
        }

        const updateData = await updateOrganization(values, values.id);
        if (updateData.err) {
          NotifyMessage({ message: updateData.err, type: "error" });
        } else {
          NotifyMessage({
            message: "Organization successfully updated",
            type: "success",
          });
          console.log(updateData);
          setOpenPopup(false);
          localStorage.setItem(
            "oranization",
            JSON.stringify(updateData.organization?.profilePicture)
          );
          resetForm();
          getAdminData();
        }
      } catch (error) {
        NotifyMessage({
          message: "Failed to update organization!",
          type: "error",
        });
      }
    }
  };
  const firstFieldRef = useRef(null);
  useEffect(() => {
    if (firstFieldRef.current) {
      firstFieldRef.current.focus();
    }
  }, []);
  return (
    <Form onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Controls.Input
            name="email"
            label="Email"
            value={values.email}
            onChange={handleInputChange}
            error={errors.email}
            inputRef={firstFieldRef}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Controls.Input
            name="phoneNo"
            label="Phone Number"
            value={values.phoneNo}
            onChange={handleInputChange}
            error={errors.phoneNo}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Controls.Input
            name="organization_name"
            label="Organization Name"
            value={values.organization_name}
            onChange={handleInputChange}
            error={errors.organization_name}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Controls.Input
            name="address"
            label="Address"
            value={values.address}
            onChange={handleInputChange}
            error={errors.address}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <div className="flex space-x-3 items-center">
            {file ? (
              <img className={classes.icon} src={file} alt="Profile Preview" />
            ) : (
              <img
                className={classes.icon}
                src={`${Image_API}/${recordForEdit?.profilePicture}`}
                alt="Profile Preview"
              />
            )}
            <Controls.Input
              name="profilePicture"
              type="file"
              label="Image"
              onChange={handleImageChange}
              autoFocus={true}
            />
          </div>
        </Grid>
        <Grid item xs={12} md={6} />
        <Grid item xs={12} md={6}>
          <div>
            <Controls.Button
              disabled={values.submitting ? true : false}
              text={
                recordForEdit
                  ? values.submitting
                    ? "Editing..."
                    : "Done"
                  : values.submitting
                  ? "Adding..."
                  : "Add"
              }
              type="submit"
            />
            <Controls.Button
              text={"Cancel"}
              color="default"
              onClick={() => {
                setOpenPopup(false);
              }}
            />
          </div>
        </Grid>
      </Grid>
    </Form>
  );
};

export default UpdateCompany;
